module.exports = __webpack_public_path__ + "static/media/quote-dunning-selfinsight-fr.16f64d70.png";